import { Descendant } from "slate";

export const EMPTY_EDITOR_STATE: Descendant[] = [{ type: "paragraph", children: [{ text: "" }] }];
